<template>
  <div class="coursemanagement">
    <div class="header">
      课程：<el-input v-model="CourseName" :placeholder="$t('Education.languages16')+$t('Education.languages10')+$t('Education.languages01')" style="width: 200px;margin-right: 30px"></el-input>
      录入人：<el-input v-model="CourseName" :placeholder="$t('Education.languages40')" style="width: 200px;margin-right: 30px"></el-input>
      <el-input v-model="CourseName" :placeholder="$t('Education.languages41')" style="width: 200px;margin-right: 30px"></el-input>
      <el-button type="primary">{{ $t('Education.languages01') }}</el-button>
    </div>

    <div class="content">
      <el-table
          :data="CourseData"
          :cell-style="{'text-align':'center'}"
          style="width: 100%;margin-bottom: 30px;">
        <el-table-column
            type="selection"
            width="55"></el-table-column>
        <el-table-column
            prop="date"
            label="日期"
            width="180">
        </el-table-column>
        <el-table-column
            prop="name"
            label="姓名"
            width="180">
        </el-table-column>
        <el-table-column
            prop="address"
            label="地址">
        </el-table-column>
        <el-table-column :label="$t('Education.languages42')">
          <template v-slot="scope">
            <span class="operateitem" @click="topicdetail=true">{{ $t('Education.languages09') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary">{{ $t('Education.languages43') }}</el-button>
      <el-button @click="$router.go(-1)">{{ $t('Education.languages44') }}</el-button>
    </div>
    <el-drawer
        :size="500"
        :visible.sync="topicdetail">
      <questiondetail @questiondetail="topicdetail=false"></questiondetail>
    </el-drawer>
  </div>
</template>

<script>
import questiondetail from './component/questiondetail.vue';
export default ({
  name:'addquestion',
  data(){
    return{
      topicdetail:false,
      CourseName:'',
      CourseData:[{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],

    }
  },
  watch(){

  },
  created() {
  },
  mounted() {
  },
  methods:{

  },
  components:{
    questiondetail
  }
})
</script>
<style scoped>
.header{display: flex;align-items:center;background: #fff;padding:30px;}
.content{background:#fff;padding:30px;margin-top:20px;}
.operateitem{padding: 0 5px 0 0;color: #0d78e3;cursor: pointer;}
</style>